// @ts-ignore
 
import request from "src/lib/axios";

/** 按业务场景（scene 字段）聚合 GET /api/v1/hq/ai-usage/by-scene */
export async function AiUsageControllerBySceneV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AiUsageControllerBySceneV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.AiUsageBySceneItemDto[]>(
    "/api/v1/hq/ai-usage/by-scene",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** Top N 商户用量排行 GET /api/v1/hq/ai-usage/by-tenant */
export async function AiUsageControllerByTenantV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AiUsageControllerByTenantV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.AiUsageByTenantItemDto[]>(
    "/api/v1/hq/ai-usage/by-tenant",
    {
      method: "GET",
      params: {
        // limit has a default value: 10
        limit: "10",
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 最近 N 月趋势（含本月） GET /api/v1/hq/ai-usage/monthly-trend */
export async function AiUsageControllerMonthlyTrendV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AiUsageControllerMonthlyTrendV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.AiUsageMonthlyTrendItemDto[]>(
    "/api/v1/hq/ai-usage/monthly-trend",
    {
      method: "GET",
      params: {
        // months has a default value: 6
        months: "6",
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 全租户月度配额 + 告警等级 GET /api/v1/hq/ai-usage/quota */
export async function AiUsageControllerListQuotaV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AiUsageControllerListQuotaV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.AiUsageQuotaItemDto[]>("/api/v1/hq/ai-usage/quota", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** Upsert 商户月度 token 配额 PATCH /api/v1/hq/ai-usage/quota/${param0} */
export async function AiUsageControllerUpsertQuotaV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AiUsageControllerUpsertQuotaV1Params,
  body: MyApi.UpdateAiUsageQuotaDto,
  options?: { [key: string]: any }
) {
  const { tenantId: param0, ...queryParams } = params;
  return request<MyApi.AiUsageQuotaItemDto>(
    `/api/v1/hq/ai-usage/quota/${param0}`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 总览：时间窗口内 tokens / cost / 调用次数 / 命中率 GET /api/v1/hq/ai-usage/summary */
export async function AiUsageControllerSummaryV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AiUsageControllerSummaryV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.AiUsageSummaryDto>("/api/v1/hq/ai-usage/summary", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
